<ion-button (click)="dismiss()" color="dark" fill="clear" class="close-modal">
  <ion-icon name="close-outline"></ion-icon>
</ion-button>

<ion-content>


  <ion-grid class="newsletter-grid" *ngIf="newsletterConfiguration$ | async as newsletterConfiguration">
    <form [formGroup]="newsletterForm" (ngSubmit)="onSubmit$$.next(newsletterForm)">

      <ion-row [class.no-image]="!newsletterConfiguration.subscription.imageUrl"
        *ngIf="newsletterConfiguration?.subscription?.imageUrl">

        <ion-col size="12">
          <div class="image-banner desktop-banner">
            <img loading="lazy" [src]="newsletterConfiguration?.subscription?.imageUrl" alt="newsletter-desktop-banner" />
          </div>

          <div class="image-banner mobile-banner">
            <img loading="lazy" [src]="newsletterConfiguration?.subscription?.imageUrl" alt="newsletter-mobile-banner" />
          </div>
        </ion-col>

      </ion-row>

      <ion-row *ngIf="newsletterConfiguration.banner" class="ion-align-items-start">

        <ion-col class="form-col" size="12">
          <h6 class="label">{{ newsletterConfiguration?.banner?.title }}</h6>
          <div class="ion-margin-bottom"
            [innerHTML]="sanitizeService.sanitizeString(newsletterConfiguration?.banner?.description)"></div>
        </ion-col>


        <ion-col class="form-col" size-xs="12" size-md="6">
          <ion-list class="form-block">
            <ion-item lines="none">
              <ion-label position="stacked">{{ 'FIELDS.NAME' | translate }}*</ion-label>
              <ion-input formControlName="name"></ion-input>
            </ion-item>
            <app-input-error [control]="newsletterForm.get('name')"></app-input-error>
            <ion-item lines="none">
              <ion-label position="stacked">{{ 'FIELDS.SURNAME' | translate }}*</ion-label>
              <ion-input formControlName="surname"></ion-input>
            </ion-item>
            <app-input-error [control]="newsletterForm.get('surname')"></app-input-error>
            <ion-item lines="none">
              <ion-label position="stacked">{{ 'FIELDS.EMAIL' | translate }}*</ion-label>
              <ion-input formControlName="email"></ion-input>
            </ion-item>
            <app-input-error [control]="newsletterForm.get('email')"></app-input-error>
          </ion-list>

        </ion-col>


        <ion-col class="form-col" size-xs="12" size-md="6">
          <ion-list  class="form-block">
            <ion-item lines="none">
              <ion-label position="stacked">{{ 'FIELDS.ZIP_CODE' | translate }}*</ion-label>
              <ion-input formControlName="zipCode"></ion-input>
            </ion-item>
            <app-input-error [control]="newsletterForm.get('zipCode')"></app-input-error>
            <ion-item lines="none">
              <ion-label position="stacked">{{ 'FIELDS.PHONE' | translate }}</ion-label>
              <ion-input type="tel" formControlName="phone"></ion-input>
            </ion-item>

            <ng-container
              *ngIf="newsletterConfiguration.checks && newsletterConfiguration.checks.politicsPrivacy && newsletterConfiguration.checks.politicsPrivacy.legalText">

              <ion-item class="item-checkbox" lines="none">
                <ion-checkbox mode="md" formControlName="privacyPolicy" slot="start"></ion-checkbox>
                <div class="custom-checkbox-label"
                  [innerHTML]="newsletterConfiguration.checks.politicsPrivacy.legalText">
                </div>
              </ion-item>
              <app-input-error [control]="newsletterForm.get('privacyPolicy')"></app-input-error>

            </ng-container>

          </ion-list>

        </ion-col>

        <ion-col size="12">
          <ion-note> * {{ 'FIELDS.MANDATORY' | translate }} </ion-note>
        </ion-col>
      </ion-row>


      <!-- <ion-row>
        <ion-col class="checks-col" size-xs="12" size-md="12">
          <ion-note>
            {{ newsletterConfiguration.subscription.legalText }}
          </ion-note>
        </ion-col>
      </ion-row> -->




      <ion-row class="ion-justify-content-between">
        <ion-col size-xs="12" size-md="auto">
          <ion-button type="submit" size="large">
            {{ 'ACTIONS.SEND' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>



    </form>
  </ion-grid>
</ion-content>